import { actions } from './index';

export const getAllSettingsSucceed = payload => ({
  type: actions.GET_ALL_SETTINGS_SUCCEED,
  payload
});
export const updateAllSettingSucceed = payload => ({
  type: actions.UPDATE_SETTING_SUCCEED,
  payload
});
